import React, { useState } from "react"
import styled from "styled-components"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"

const StyledDatePicker = styled.div`
  .react-datepicker {
    border: 1px solid var(--base-gray30, #d1d1d1);
    border-radius: 8px;
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
    background: var(--base-gray5, #f0f0f0);
  }

  .react-datepicker__header {
    background: var(--base-gray5, #f0f0f0);
    border-bottom: 1px solid var(--base-gray30, #d1d1d1);
  }

  .react-datepicker__month-text--selected,
  .react-datepicker__month-text:hover {
    background: var(--secondary80, #4282ef);
    color: white;
    border-radius: 4px;
  }
`

const CustomInput = styled.input`
  width: 124px; /* 너비 설정 */
  display: flex;
  padding: 8px 10px;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--base-gray30, #d1d1d1);
  background: var(--base-gray5, #f0f0f0);
  font-family: SUIT;
  font-size: 16px;
  font-weight: 500;
`

interface Props {
  selectedMonth: Date | null
  setSelectedMonth: React.Dispatch<React.SetStateAction<Date | null>>
}

const MonthPicker = (props: Props) => {
  const { selectedMonth, setSelectedMonth } = props

  const handleDateChange = (
    date: Date | null,
    event?: React.SyntheticEvent<any>
  ) => {
    setSelectedMonth(date)
  }

  return (
    <StyledDatePicker>
      <DatePicker
        selected={selectedMonth}
        onChange={handleDateChange}
        dateFormat="yyyy.MM"
        showMonthYearPicker
        placeholderText="2025.01"
        customInput={<CustomInput />} /* 커스텀 input 적용 */
      />
    </StyledDatePicker>
  )
}

export default MonthPicker
